export default "<ngx-ui-loader></ngx-ui-loader>\r\n<router-outlet></router-outlet>";